module.exports = __webpack_public_path__ + "static/media/darkskylogo.a509dfef.png";